import { usePageVisibility } from "react-page-visibility";

export const usePollInterval = (value: number, fallback?: number): number => {
  const isVisible = usePageVisibility();
  return isVisible ? value : fallback ?? 0;
};
